import { Pipe, PipeTransform } from '@angular/core';
import { TipoEmpresaEnum } from '../api';

@Pipe({
  name: 'tipoEmpresa'
})
export class TipoEmpresaPipe implements PipeTransform {

    transform(value: TipoEmpresaEnum | string | undefined): string {
        if (!value)
        return 'Desconhecido'
        return TipoEmpresaEnumDescriptions[value as TipoEmpresaEnum] || 'Desconhecido';
    }

}

export const TipoEmpresaEnumDescriptions: { [key in TipoEmpresaEnum]: string } = {
1: "Empresa do sector",
2: "Manpower",
};